import { render, staticRenderFns } from "./ListAuditoriaTransfolhaView.vue?vue&type=template&id=52480669&"
import script from "./ListAuditoriaTransfolhaView.vue?vue&type=script&lang=ts&"
export * from "./ListAuditoriaTransfolhaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports